import { IUser } from "@/features/auth/model/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type AuthState = {
  user: IUser | null;
  setUser: (user: IUser | null) => void;
  logOut: () => void;
};

export const useAuthStore = create<AuthState, [["zustand/persist", AuthState]]>(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }),
      logOut: () => set({ user: null }),
    }),
    {
      name: "auth-storage",
    }
  )
);
